import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

var ROSwitch =
/** @class */
function (_super) {
  __extends(ROSwitch, _super);

  function ROSwitch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.on = false;
    return _this;
  }

  ROSwitch.prototype.onPropValueChange = function (val) {
    this.on = val;
  };

  ROSwitch.prototype.onOnChange = function (val) {
    this.$emit('input', val);
  };

  ROSwitch.prototype.onClick = function () {
    this.$emit('click', !this.on, this.switchKey);
  };

  ROSwitch.prototype.created = function () {
    this.on = this.value;
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], ROSwitch.prototype, "value", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], ROSwitch.prototype, "switchKey", void 0);

  __decorate([Watch('$props.value')], ROSwitch.prototype, "onPropValueChange", null);

  __decorate([Watch('on')], ROSwitch.prototype, "onOnChange", null);

  ROSwitch = __decorate([Component({
    name: 'ROSwitch'
  })], ROSwitch);
  return ROSwitch;
}(Vue);

export default ROSwitch;